<span class="times-display">
  <span *ngFor="let timeEntry of orderedTimes; let last = last" class="day-schedule" [class.current-day]="isCurrentDay(timeEntry.day)">
    {{ getDayName(timeEntry.day) }}: {{ formatHours(timeEntry.hours) }}<span *ngIf="!last">, </span>
  </span>
</span>
